import React from 'react';
import classes from './DisplayTextArea.module.css';
import { formImages, truncateText } from 'shared/utility';

const displayTextArea = (props) => {
  const contentContainerClasses = [classes.InputDiv, classes[props.type]];

  if (props.selected === true) {
    contentContainerClasses.push(classes.Selected);
  }

  if (props.shortWindow === true) contentContainerClasses.push(classes.ShortWindow);
  if (props.isGift === true) contentContainerClasses.push(classes.GiftPost);

  let validationError = null;
  if (props.validationError && props.invalid && props.touched && props.shouldValidate) {
    validationError = <p className={classes.ValidationError}>{props.validationError}</p>;
  }
  let guideText = null;
  if (props.guidetext && validationError == null) {
    guideText = <p className={classes.GuideText}>{props.guidetext}</p>;
  }

  let iconImage = props.iconImage ? formImages.find((formImage) => formImage.name === props.iconImage) : null;
  iconImage = iconImage ? <iconImage.image className={classes.ImageIcon} /> : null;

  // const contentElement = document.getElementById(`content-${props.type}`);

  const contentContainerHeight =
    props.lines && props.lines === 4 && props.value && ((props.drawerOpen && props.value.length > 161) || props.value.length > 315) ? 71 : 54;
  const maxContentHeight = props.lines && props.lines === 4 ? 65 : 49;

  const value = ['Title', 'About'].includes(props.type)
    ? props.drawerOpen
      ? props.lines && props.lines === 4
        ? truncateText(props.value, 235)
        : truncateText(props.value, 170)
      : props.lines && props.lines === 4
      ? truncateText(props.value, 481)
      : truncateText(props.value, 370)
    : props.value;

  return (
    <div
      style={{ maxHeight: `${contentContainerHeight}px`, height: `${contentContainerHeight}px` }}
      name={props.type}
      onClick={props.clicked}
      className={contentContainerClasses.join(' ')}
    >
      <div className={classes.InnerContentContainer}>
        {value.length > 0 ? (
          <p className={classes.FieldValue} style={{ maxHeight: `${maxContentHeight}px` }} id={`content-${props.type}`}>
            {value.split('\n')[0]}
            {value.split('\n').length > 1 ? <br /> : null}
            {value.split('\n').length > 1 ? value.split('\n')[1] : null}
          </p>
        ) : (
          <p className={classes.Placeholder}>{props.placeholder}</p>
        )}

        {guideText}
      </div>
      <div className={classes.IconContainer}>{iconImage}</div>
    </div>
  );
};

export default displayTextArea;
